import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FwAlertModule } from '@flywheel-io/vision';
import { MaterialModule } from 'app/src/material.module';
import { PipesModule } from 'app/src/shared/pipes.module';

@Component({
  selector: 'upload-dropzone',
  styleUrls: ['./upload-dropzone.component.scss'],
  templateUrl: './upload-dropzone.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    FwAlertModule,
    ReactiveFormsModule,
    MaterialModule,
    PipesModule,
  ],
})
export class UploadDropzoneComponent {
  @Output() afterFilesAdded = new EventEmitter<FileList>();

  dropFiles(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.afterFilesAdded.emit(event.dataTransfer.files);
  }

  selectFiles(event: Event): void {
    this.afterFilesAdded.emit((event.target as HTMLInputElement).files);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const element = event.currentTarget as HTMLInputElement;
    if (!element.classList.contains('active')) {
      element.classList.add('active');
    }
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    const element = event.currentTarget as HTMLInputElement;
    if (element.classList.contains('active')) {
      element.classList.remove('active');
    }
  }
}
